// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1m-Ar","label":"styles_label__1rT6m"};